import { Ave, Mode, PunchcardCategory } from './types';

export const PANICKY_FUZZY_SCORE = 0.76;
export const PASSABLE_FUZZY_SCORE = 0.84;
export const POISED_FUZZY_SCORE = 0.92;

export const AVES: Ave[] = [
  {
    name: 'bogey',
    score: 1,
    color: { dark: '', light: '' },
    shineColor: { dark: '', light: '' },
  },
  {
    name: 'par',
    score: 0,
    color: { dark: '#AC724C', light: '#cda68c' },
    shineColor: { dark: '#AC724CB3', light: '#cda68cb3' }, //'rgba(205, 166, 140, 0.7)',
  },
  {
    name: 'birdie',
    score: -1,
    color: { dark: '#00B600', light: '#00FF00' },
    shineColor: { dark: '#00B600B3', light: '#00FF00B3' }, //'rgba(0, 255, 0, 0.7)',
  },
  {
    name: 'eagle',
    score: -2,
    color: { dark: '#43B5C4', light: '#B0E0E6' },
    shineColor: { dark: '#43B5C4B3', light: '#B0E0E6B3' }, //'rgba(176, 224, 230, 0.7)',
  },
  {
    name: 'albatross',
    score: -3,
    color: { dark: '#D80073', light: '#FF1493' },
    shineColor: { dark: '#D80073B3', light: '#FF1493B3' }, //'rgba(255, 20, 147, 0.7)',
  },
  {
    name: 'condor',
    score: -4,
    color: { dark: '#C86E00', light: '#ff8c00' },
    shineColor: { dark: '#C86E00B3', light: '#ff8c00B3' }, //'rgba(255, 140, 0, 0.7)',
  },
  {
    name: 'ostrich',
    score: -5,
    color: { dark: '#E43CE4', light: '#EE82EE' },
    shineColor: { dark: '#E43CE4B3', light: '#EE82EEB3' }, //'rgba(238, 130, 238, 0.7)',
  },
  {
    name: 'pterodactyl',
    score: -6,
    color: { dark: '#AFA429', light: '#E6DF93' },
    shineColor: { dark: '#AFA429B3', light: '#E6DF93B3' }, // 'rgba(230, 223, 147, 0.7)',
  },
];

export const MEDAL_COLORS: { [key: string]: string } = {
  bronze: '#CD7f32',
  silver: '#B4B4B4',
  gold: '#FFCA09',
  platinum: '#E5E4E2',
  diamond: '#54c7f0',
  unobtainium: '#ff0000',
  antimatter: '#cbcbcb',
};

export type MedalRequirements = {
  bronze: number;
  silver: number;
  gold: number;
  platinum: number;
  diamond: number;
  unobtainium: number;
  antimatter: number;
};

export const MEDAL_REQUIREMENTS: Record<PunchcardCategory, MedalRequirements> =
  {
    average: {
      bronze: 40,
      silver: 30,
      gold: 20,
      platinum: 0,
      diamond: -20,
      unobtainium: -40,
      antimatter: -50,
    },
    bestAverage: {
      bronze: 40,
      silver: 30,
      gold: 20,
      platinum: 0,
      diamond: -20,
      unobtainium: -40,
      antimatter: -50,
    },
    best: {
      bronze: 20,
      silver: 10,
      gold: 0,
      platinum: -20,
      diamond: -40,
      unobtainium: -60,
      antimatter: -70,
    },
    gamesPlayed: {
      bronze: 25,
      silver: 50,
      gold: 100,
      platinum: 150,
      diamond: 250,
      unobtainium: 500,
      antimatter: 1000,
    },
  };

export const MODE_DISPLAY_NAME: Partial<Record<Mode, string>> = {
  solo: 'Solo',
  match: 'Match',
  teams: 'Teams',
  'sit-n-go': 'Sit & Go',
};

export const CATEGORY_SETS_LABEL: Record<string, string> = {
  all: 'All',
  fineArts: 'Fine Arts',
  hardSoftSciences: 'Hard & Soft Sciences',
  humanities: 'Humanities',
  popCulture: 'Pop Culture',
};

export const MODE_ABBR: Partial<Record<Mode, string>> = {
  solo: 'Solo',
  match: 'Match',
  'sit-n-go': 'SnG',
  teams: 'Teams',
};
